var diff = require("./vtree/diff.js")

module.exports = diff



//////////////////
// WEBPACK FOOTER
// ./~/virtual-dom/diff.js
// module id = 44
// module chunks = 0